/**
 * `ChartTip` — the single tooltip node §F2 gives every chart ("tooltips via shared
 * `ChartTip` portal"), i.e. the mockup's `<div class="charttip" id="charttip">`.
 *
 * Mounted **once**, next to `<Toast/>` in the app shell; charts never render it, they only
 * call `showChartTip` / `hideChartTip` from `./chartTipStore` (which is where the store and the
 * reasoning behind it live). A portal on `document.body` keeps it out of every widget's
 * stacking and clipping context.
 */
import { useEffect, useState, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';

import { readChartTip, subscribeChartTip } from './chartTipStore';

export function ChartTip() {
  const state = useSyncExternalStore(subscribeChartTip, readChartTip, readChartTip);
  // The portal target only exists after the first client render, so it is resolved in an
  // effect rather than at module scope (which would also break the vitest jsdom setup).
  const [host, setHost] = useState<HTMLElement | null>(null);
  useEffect(() => setHost(document.body), []);

  if (!host || !state) return null;

  return createPortal(
    <div className="charttip" role="status" style={{ left: state.x + 14, top: state.y - 10 }}>
      <span className="ct-label">{state.label}</span>
      <b>{state.value}</b>
    </div>,
    host,
  );
}

export default ChartTip;
